/**
 * InvoicesToolbar — status tabs + search box.
 * Extracted from Invoices.js to keep page under reasonable size. Stateless;
 * controlled entirely by parent.
 */
import { Search } from 'lucide-react';

const TABS = [
  // "All" now shows every unpaid invoice — fully paid ones move to the "Paid"
  // tab and the customer's history modal so the working queue stays clean.
  { key: 'all', label: 'All Open' },
  { key: 'draft', label: 'Drafts' },
  { key: 'pending', label: 'Pending' },
  { key: 'partial', label: 'Partial' },
  { key: 'paid', label: 'Paid' },
  { key: 'overdue', label: 'Overdue' },
];

export default function InvoicesToolbar({
  filterStatus,
  onFilterChange,
  statusCounts,
  search,
  onSearchChange,
}) {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 14,
        border: '1px solid #e5e7eb',
        padding: 10,
        marginBottom: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexWrap: 'wrap',
        boxShadow: '0 1px 2px rgba(15,23,42,0.04)',
      }}
    >
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', flex: 1 }}>
        {TABS.map((t) => {
          const active = filterStatus === t.key;
          return (
            <button
              key={t.key}
              data-testid={`invoice-tab-${t.key}`}
              onClick={() => onFilterChange(t.key)}
              style={{
                all: 'unset',
                cursor: 'pointer',
                padding: '9px 18px',
                borderRadius: 999,
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 0.1,
                background: active ? '#0073ea' : 'transparent',
                color: active ? '#fff' : '#475569',
                border: `1px solid ${active ? '#0073ea' : '#e5e7eb'}`,
                boxShadow: active ? '0 3px 10px rgba(0,115,234,0.28)' : 'none',
                transition: 'background 0.15s, color 0.15s, box-shadow 0.15s, border-color 0.15s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
              }}
              onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = 'rgba(15,23,42,0.05)'; }}
              onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = 'transparent'; }}
            >
              {t.label}
              {statusCounts[t.key] > 0 && (
                <span
                  style={{
                    background: active ? 'rgba(255,255,255,0.25)' : '#f1f5f9',
                    color: active ? '#fff' : '#64748b',
                    fontSize: 10,
                    padding: '1px 7px',
                    borderRadius: 999,
                    fontWeight: 700,
                  }}
                >
                  {statusCounts[t.key]}
                </span>
              )}
            </button>
          );
        })}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: '#f8fafc',
          border: '1px solid #e5e7eb',
          borderRadius: 10,
          padding: '6px 12px',
          minWidth: 200,
        }}
      >
        <Search size={14} color="#94a3b8" />
        <input
          data-testid="invoice-search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search invoice # or customer…"
          style={{
            all: 'unset',
            flex: 1,
            fontSize: 13,
            color: '#0f172a',
            width: '100%',
            minWidth: 0,
          }}
        />
      </div>
    </div>
  );
}
